module.exports = {"benefits":"Benefícios","consumption":"Consumo","currency":"R$","messageTax":"* Essa fatura não tem valor fiscal e será considerada quitada após a confirmação do débito em conta ou do lançamento em cartão de crédito.","messageTax2":"** Conforme lei 12.741/12 e IBPT, o valor aproximado dos tributos na prestação de serviço de concessionária operadora de rodovia (pedágio) é de 18,45% e a responsabilidade pelo recolhimento é da respectiva concessionária","subtotal":"Subtotal","total":"total","veloeServices":"Serviços Veloe"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/InvoiceResume/data.json
// module id = 2081
// module chunks = 0